"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.array.concat.js");
var _pullRefresh = _interopRequireDefault(require("../pull-refresh"));
var _list = _interopRequireDefault(require("../list"));
var _stance = _interopRequireDefault(require("../stance"));
// import PageModel from './PageModel';
var _default2 = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('z-pull-refresh', {
      on: {
        "refresh": _vm.refresh
      },
      model: {
        value: _vm.isFreshing,
        callback: function callback($$v) {
          _vm.isFreshing = $$v;
        },
        expression: "isFreshing"
      }
    }, [_c('z-list', {
      ref: "zlist",
      attrs: {
        "immediate-check": _vm.autoFirstLoad,
        "finished": _vm.isFinished,
        "offset": 30,
        "finished-text": _vm.dataList.length ? _vm.finishedText : ''
      },
      on: {
        "load": _vm._loadmore
      },
      model: {
        value: _vm.isLoading,
        callback: function callback($$v) {
          _vm.isLoading = $$v;
        },
        expression: "isLoading"
      }
    }, [_vm.showStance && !_vm.dataList.length && !_vm.isLoading ? _c('z-stance', {
      attrs: {
        "type": _vm.stanceType,
        "info": _vm.stanceInfo,
        "show-btn": false
      }
    }) : _vm._e(), _vm._t("default", null, {
      "dataList": _vm.dataList,
      "headerList": _vm.headerList
    })], 2)], 1);
  },
  name: 'z-biz-refresh-list',
  components: {
    'z-pull-refresh': _pullRefresh.default,
    'z-list': _list.default,
    'z-stance': _stance.default
  },
  props: {
    loadmore: {
      default: function _default() {
        return function () {
          return new Promise(function (resolve, reject) {
            return resolve({
              dataList: []
            });
          });
        };
      },
      type: Function
    },
    loadmoreAgain: {
      default: null,
      type: Function
    },
    autoFirstLoad: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 10
    },
    reload: {
      type: Boolean,
      default: false
    },
    filterParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pageSizeEffect: {
      type: Boolean,
      default: false
    },
    finishedText: {
      type: String,
      default: '到底了'
    },
    showStance: {
      // 是否展示占位图
      type: Boolean,
      default: false
    },
    stanceType: {
      // 占位图类型
      type: String,
      default: 'data'
    },
    stanceInfo: {
      // 占位图文案
      type: String,
      default: '还没有数据哦'
    }
  },
  data: function data() {
    return {
      isFirstLoaded: false,
      headerList: [],
      // header列表
      dataList: [],
      // 商品列表
      page: {
        pageNum: 1,
        pageSize: this.pageSize
      },
      isLoading: false,
      // 是否正在加载更多
      isFreshing: false,
      // 是否正在刷新
      isFinished: false,
      // 是否已经没有更多数据了
      firstApiFinished: false // 第一个接口加载是否完成标识
    };
  },

  watch: {
    reload: function reload(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.refresh();
      }
    },
    autoFirstLoad: function autoFirstLoad(newVal, oldVal) {
      if (newVal && !this.isFirstLoaded) {
        this.firstLoad();
      }
    }
  },
  methods: {
    firstLoad: function firstLoad() {
      this.$refs.zlist.check();
      this.isFirstLoaded = true;
    },
    _loadmore: function _loadmore() {
      console.log('123');
      if (this.loadmoreAgain) {
        this._getListDataByTwoApi();
      } else {
        this._getListDataByOneApi();
      }
    },
    refresh: function refresh() {
      this.page.pageNum = 1;
      this.isFinished = false;
      this.isLoading = true;
      this.firstApiFinished = false; // 第一个接口加载完标识
      this._loadmore();
    },
    // 获取一个接口数据
    _getListDataByOneApi: function _getListDataByOneApi() {
      var _this = this;
      var params = Object.assign({}, this.filterParams, this.page);
      this.loadmore(params).then(function (res) {
        if (res && Array.isArray(res.dataList)) {
          _this.dataList = params.pageNum === 1 ? [].concat(res.dataList) : _this.dataList.concat(res.dataList);
          if (params.pageNum === 1 && res.headers && Array.isArray(res.headers)) {
            _this.headerList = [].concat(res.headers);
          }
          _this.page.pageNum += 1;
          _this.isLoading = false;
          _this.isFreshing = false;
          var comparePageSize = _this.pageSizeEffect ? 1 : _this.page.pageSize;
          if (res.dataList.length < comparePageSize) {
            _this.isFinished = true;
          }
        }
      }).catch(function (err) {
        _this.isFreshing = false;
        console.log(err);
      });
    },
    // 获取两个接口数据
    _getListDataByTwoApi: function _getListDataByTwoApi() {
      var _this2 = this;
      var params = Object.assign({}, this.filterParams, this.page);
      if (!this.firstApiFinished) {
        // 第一次接口请求
        this.loadmore(params).then(function (res) {
          if (res && Array.isArray(res.dataList)) {
            _this2.dataList = params.pageNum === 1 ? [].concat(res.dataList) : _this2.dataList.concat(res.dataList);
            if (params.pageNum === 1 && res.headers && Array.isArray(res.headers)) {
              _this2.headerList = [].concat(res.headers);
            }
            _this2.page.pageNum += 1;
            _this2.isLoading = false;
            _this2.isFreshing = false;
            var comparePageSize = _this2.pageSizeEffect ? 1 : _this2.page.pageSize;
            if (res.dataList.length < comparePageSize) {
              _this2.firstApiFinished = true;
              _this2.page.pageNum = 1;
            }
          }
        }).catch(function (err) {
          _this2.isFreshing = false;
          console.log(err);
        });
      } else {
        // 第二次接口请求
        this.loadmoreAgain(params).then(function (res) {
          if (res && Array.isArray(res.dataList)) {
            _this2.dataList = _this2.dataList.concat(res.dataList);
            _this2.isLoading = false;
            _this2.isFreshing = false;
            if (res.pageInfo) {
              // 传了返回页数,兼容去重list中间页面去重完为空的情况
              // 返回的下次请求页数比当前页数大，赋值页数，继续请求
              var currentPageNum = Number(res.pageInfo.pageNum || 1);
              if (currentPageNum > _this2.page.pageNum) {
                _this2.page.pageNum = currentPageNum;
              } else {
                if (res.dataList.length === 0) _this2.isFinished = true;else _this2.page.pageNum += 1;
              }
            } else {
              // 正常的处理返回列表的情况
              _this2.page.pageNum += 1;
              var comparePageSize = _this2.pageSizeEffect ? 1 : _this2.page.pageSize;
              if (res.dataList.length < comparePageSize) {
                _this2.isFinished = true;
              }
            }
          }
        }).catch(function (err) {
          _this2.isFreshing = false;
          console.log(err);
        });
      }
    }
  }
};
exports.default = _default2;